const DIAS = [
  { slot: 'lu', flag: 'lunes' },
  { slot: 'ma', flag: 'martes' },
  { slot: 'mi', flag: 'miercoles' },
  { slot: 'ju', flag: 'jueves' },
  { slot: 'vi', flag: 'viernes' },
]

const TEACHERS_IGNORAR = [0, 1202]

function redondear (n) {
  return Math.round((Number(n) || 0) * 100) / 100
}

function nombreEscuela (id) {
  return Number(id) === 2 ? 'FAST' : 'INBI'
}

function esTeens (grupo) {
  const nombre = (grupo && grupo.grupo) ? String(grupo.grupo).toUpperCase() : ''
  return nombre.indexOf('TEENS') !== -1
}

function teacherValido (idTeacher, nombre) {
  if (idTeacher == null || idTeacher === '') return false
  const n = Number(idTeacher)
  if (TEACHERS_IGNORAR.indexOf(n) !== -1) return false
  if (!nombre) return false
  const nom = String(nombre).toUpperCase()
  if (nom === 'SIN TEACHER') return false
  return true
}

function horasSabDom (grupo, idTeacher, semana, teens, horasDia) {
  const slots = teens ? ['lu', 'ma', 'mi'] : ['lu', 'ma', 'mi', 'ju', 'vi']
  if (teens) {
    let asignado = false
    for (let i = 0; i < slots.length; i++) {
      if (grupo[slots[i] + semana] == idTeacher) {
        asignado = true
        break
      }
    }
    return asignado ? (horasDia || 3) : 0
  }
  let horas = 0
  for (let i = 0; i < slots.length; i++) {
    if (grupo[slots[i] + semana] == idTeacher) {
      horas += 1
    }
  }
  return horas
}

function horasEntreSemana (grupo, idTeacher, semana, horasDia) {
  let horas = 0
  for (let i = 0; i < DIAS.length; i++) {
    const d = DIAS[i]
    if (grupo[d.flag] && grupo[d.slot + semana] == idTeacher) {
      horas += horasDia
    }
  }
  return horas
}

export function semanaDelCiclo (fechaInicio) {
  if (!fechaInicio) return 1
  const partes = String(fechaInicio).substring(0, 10).split('-')
  if (partes.length !== 3) return 1
  const inicio = new Date(Number(partes[0]), Number(partes[1]) - 1, Number(partes[2]))
  const hoy = new Date()
  hoy.setHours(0, 0, 0, 0)
  inicio.setHours(0, 0, 0, 0)
  const diff = Math.floor((hoy.getTime() - inicio.getTime()) / (24 * 60 * 60 * 1000))
  if (diff < 0) return 1
  let sem = Math.floor(diff / 7) + 1
  if (sem < 1) return 1
  if (sem > 4) return 4
  return sem
}

export function filasDetalleCarga (gruposRoles, semana) {
  const grupos = (gruposRoles || []).filter(function (el) {
    return el.deleted == 0
  })
  const sem = semana || 1
  const mapa = {}

  for (let g = 0; g < grupos.length; g++) {
    const grupo = grupos[g]
    const horasDia = Number(grupo.horas_dia) || 0
    const teens = esTeens(grupo)
    const escuela = nombreEscuela(grupo.id_unidad_negocio)
    const plantel = grupo.plantel ? grupo.plantel : 'SIN PLANTEL'
    const vistos = {}

    for (let d = 0; d < DIAS.length; d++) {
      const slot = DIAS[d].slot + sem
      const idTeacher = grupo[slot]
      const nombre = grupo[slot + '_n']
      if (!teacherValido(idTeacher, nombre)) continue
      const claveTeacher = String(idTeacher)
      if (vistos[claveTeacher]) continue
      vistos[claveTeacher] = true

      let sab = 0
      let dom = 0
      let lv = 0
      if (grupo.sabado) {
        sab = horasSabDom(grupo, idTeacher, sem, teens, horasDia)
      } else if (grupo.domingo) {
        dom = horasSabDom(grupo, idTeacher, sem, teens, horasDia)
      } else {
        lv = horasEntreSemana(grupo, idTeacher, sem, horasDia)
      }

      if (!sab && !dom && !lv) continue

      const key = escuela + '|' + plantel + '|' + idTeacher
      if (!mapa[key]) {
        mapa[key] = {
          key: key,
          escuela: escuela,
          plantel: plantel,
          id_plantel: grupo.id_plantel,
          id_unidad_negocio: grupo.id_unidad_negocio,
          id_teacher: idTeacher,
          teacher: nombre,
          cantidad_grupos: 0,
          horas_entre_semana: 0,
          horas_sabatinas: 0,
          horas_dominicales: 0,
          horas_totales: 0,
        }
      }
      mapa[key].cantidad_grupos += 1
      mapa[key].horas_entre_semana += lv
      mapa[key].horas_sabatinas += sab
      mapa[key].horas_dominicales += dom
    }
  }

  return Object.keys(mapa).map(function (k) {
    const row = mapa[k]
    row.horas_entre_semana = redondear(row.horas_entre_semana)
    row.horas_sabatinas = redondear(row.horas_sabatinas)
    row.horas_dominicales = redondear(row.horas_dominicales)
    row.horas_totales = redondear(
      row.horas_entre_semana + row.horas_sabatinas + row.horas_dominicales
    )
    return row
  })
}

export function filasUnicasCarga (filasDetalle) {
  const mapa = {}
  const base = filasDetalle || []
  for (let i = 0; i < base.length; i++) {
    const row = base[i]
    const key = String(row.id_teacher)
    if (!mapa[key]) {
      mapa[key] = {
        id_teacher: row.id_teacher,
        teacher: row.teacher,
        cantidad_grupos: 0,
        horas_totales: 0,
      }
    }
    mapa[key].cantidad_grupos += row.cantidad_grupos
    mapa[key].horas_totales += row.horas_totales
  }
  return Object.keys(mapa).map(function (k) {
    const row = mapa[k]
    row.horas_totales = redondear(row.horas_totales)
    return row
  })
}

export function mapaCargaUnicos (gruposRoles, semana, filtros) {
  let detalle = filasDetalleCarga(gruposRoles, semana)
  const f = filtros || {}
  if (f.id_unidad_negocio) {
    const esc = Number(f.id_unidad_negocio)
    detalle = detalle.filter(function (el) {
      return Number(el.id_unidad_negocio) === esc
    })
  }
  if (f.id_plantel) {
    const plantel = Number(f.id_plantel)
    detalle = detalle.filter(function (el) {
      return Number(el.id_plantel) === plantel
    })
  }
  const unicos = filasUnicasCarga(detalle)
  const mapa = {}
  for (let i = 0; i < unicos.length; i++) {
    mapa[Number(unicos[i].id_teacher)] = unicos[i]
  }
  return mapa
}
